export const CREDIT_NOTE_TABS = [
  { value: "total", label: "Total No. of Credit Notes" },
  { value: "current_month", label: "Current Month Credit Notes" },
  { value: "paid", label: "Paid" },
  { value: "cancelled", label: "Cancelled / Rejected" },
];

export const creditNotePermission = (section, key, action = "view") =>
  `credit_notes.${section}.${key}${action ? `.${action}` : ""}`;

export const creditNoteActionPermission = (action) => `credit_notes.actions.${action}`;

export const creditNoteListColumnPermission = (column) =>
  creditNotePermission("list_columns", column);

export const creditNoteListControlPermission = (control) =>
  creditNotePermission("list_controls", control);

export const creditNoteFormFieldPermission = (mode, field) =>
  creditNotePermission(`${mode}_fields`, field);
